import { useCallback, useState } from "react";
import { getProspectReference } from "@utils/storage";
import { postAskAvailableAppointments } from "@modules/eirSalesFacade/apis/postAskAvailableAppointments";
import { IEirSalesAskAvailableAppointments } from "@modules/eirSalesFacade/interfaces/models/IEirSalesAskAvailableAppointments";
import { useFetchState } from "@hooks/useFetchState";

interface IParams {
    offerId: number;
}

export const useAskAvailableAppointments = (props: IParams) => {
    const { offerId } = props;
    const [askAvailableAppointments, setAskAvailableAppointments] = useState<
        IEirSalesAskAvailableAppointments | undefined
    >(undefined);
    const { startFetching, endFetching, error, isLoading } = useFetchState();
    const prospectReference = getProspectReference();

    const askAvailableAppointmentsFn = useCallback(
        async (successCallback?: (askAvailableAppointments: IEirSalesAskAvailableAppointments) => void) => {
            if (!prospectReference) {
                return;
            }

            try {
                startFetching();

                const result = await postAskAvailableAppointments(prospectReference, offerId);

                if (result) {
                    setAskAvailableAppointments(result);

                    if (successCallback) {
                        successCallback(result);
                    }
                }

                endFetching();
            } catch (apiError) {
                endFetching(apiError);
            }
        },
        [endFetching, offerId, prospectReference, startFetching]
    );

    return {
        askAvailableAppointments: askAvailableAppointmentsFn,
        error,
        isLoading,
        askAvailableAppointmentsData: askAvailableAppointments,
    };
};
